import React from "react";
import { NewControlManager } from "../newControlManager";
import { LANG_V2 } from "../../shared/Data/typeDirs";
import { LanguageHeader } from "../newControlManager/controlWrappers/language_v2/header";

export function LanguageEditorArea({ onSubmit, registerGetData }) {

  return (
    <NewControlManager
      registerGetData={registerGetData}
      onSubmit={onSubmit}
      content={[]}
      schemas={[]}
      source={{}}
      onChange={() => { }}
      objectMetadata={{type:LANG_V2}}
      options={{ modules: {header: LanguageHeader} }}
    />
  )
}